<main>
  <div class="container-fluid">
    <div class="row">
      <div class="header">
        <div class="header__text">
          <h1 class="header__text--titulo">Hello! I Am William</h1>
          <p class="header__text--parrafo">
            I am a sofware engineer with knowledge in design and development
            of web pages and SPA with technologies such as Angular, React,
            Node.js, Java, Spring, Python, Mysql, MongoDB, AWS among others.
          </p>
        </div>
        <div class="header__img">
          <img
            class="header__img--principal"
            src="assets/img/Imgheader.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</main>
